module.exports = __webpack_public_path__ + "img/asset_RAY.6d3b31e5.svg";